// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/tabs/index.css
// module id = 189
// module chunks = 1